import { defineMessages } from "react-intl";

export default defineMessages({
  genetiivi: {
    id: "esiJaPerusopetus.genetiivi",
    defaultMessage: "Esi- ja perusopetuksen"
  },
  kebabCase: {
    id: "esiJaPerusopetus.kebabCase",
    defaultMessage: "esi-ja-perusopetus"
  },
  kuvausteksti: {
    id: "esiJaPerusopetus.kuvausteksti",
    defaultMessage:
      "Kunta on perusopetuslain nojalla velvollinen järjestämään sen alueella asuville oppivelvollisuusikäisille esi- ja perusopetusta. Valtioneuvosto voi myöntää opetus- ja kulttuuriministeriön esityksestä myös rekisteröidylle yhteisölle tai säätiölle luvan perusopetuslain mukaisen opetuksen järjestämiseen. Opetusta voidaan ministeriön päätöksellä järjestää myös valtion oppilaitoksessa. Tällä sivulla voit tarkastella opetuksen järjestäjiä ja niiden järjestämislupia."
  },
  lyhytKuvaus: {
    id: "esiJaPerusopetus.lyhytKuvaus",
    defaultMessage:
      "Kunta on perusopetuslain nojalla velvollinen järjestämään sen alueella asuville oppivelvollisuusikäisille esi- ja perusopetusta. Valtioneuvosto voi myöntää opetus- ja kulttuuriministeriön esityksestä myös rekisteröidylle yhteisölle tai säätiölle luvan perusopetuslain mukaisen opetuksen järjestämiseen. Opetusta voidaan ministeriön päätöksellä järjestää myös valtion oppilaitoksessa. Tällä sivulla voit tarkastella opetuksen järjestäjiä ja niiden järjestämislupia."
  },
  paasivunOtsikko: {
    id: "esiJaPerusopetus.paasivunOtsikko",
    defaultMessage: "Esi- ja perusopetuksen järjestäjät"
  },
  poOpetustehtava: {
    id: "esiJaPerusopetus.poOpetustehtava",
    defaultMessage: "PO Opetustehtävä"
  },
  esittelyteksti: {
    id: "esiJaPerusopetus.esittelyteksti",
    defaultMessage:
      "Tälle sivulle on koottu opetuksen järjestäjän järjestämisluvan perustiedot. Jos järjestäjällä on useampia voimassaolevia esi- ja perusopetuksen järjestämislupia, on niiden tiedot yhdistetty tälle sivulle. Järjestäjän luvat löytyvät alkuperäisinä kokonaisuudessaan Päätökset-välilehdeltä."
  },
  jarjestamislupa: {
    id: "esiJaPerusopetus.jarjestamislupa",
    defaultMessage: "Esi- ja perusopetuksen järjestämislupa"
  }
});
